<template>
  <div class="container account-container custom-account-container">
    <div class="row">
      <div class="sidebar widget widget-dashboard mb-lg-0 mb-3 col-lg-2 order-0">
        <h2 class="text-uppercase">{{ translations.myProfile }}</h2>
        <ul class="nav nav-tabs list flex-column mb-0" role="tablist">
          <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'ProfileDashboard' }">
              {{ translations.profileDashboard }}
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'Orders' }">
              {{ translations.orders }}
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'Messages' }">
              {{ translations.messages }}
              <span class="badge text-light" v-if="unreadMessagesCount">
                {{ unreadMessagesCount }}
              </span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'Address' }">
              {{ translations.addresses }}
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'AccountDetails' }">
              {{ translations.accountDetails }}
            </router-link>
          </li>

          <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'RMA' }">
              {{ translations.rmaForm }}
            </router-link>
          </li>
          <li class="nav-item" v-if="profile?.userData?.canViewFinances">
            <router-link class="nav-link" :to="{ name: 'ProfileFinance' }">
              {{ translations.finances }}
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'MyFiles' }">
              {{ translations.myFiles }}
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'Wishlist' }">
              {{ translations.wishlist }}
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'ShoppingCards' }">
              {{ translations.shoppingCarts }}
            </router-link>
          </li>
        </ul>
      </div>
      <div class="col-lg-10 tab-content">
        <router-view />
      </div>
      <!-- End .tab-content -->
    </div>
    <!-- End .row -->
  </div>
</template>

<script>
import { translations } from '@/mixins';

export default {
  name: 'Profile',
  mixins: [translations],
  computed: {
    profile() {
      return this.$store.getters.getProfile;
    },
    unreadMessagesCount() {
      return this.$store.getters.getUnreadMessagesCount;
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.$store.dispatch('getUnreadMessagesCount');
  },
};
</script>

<style lang="scss" scoped>
.nav-item:hover {
  cursor: pointer !important;
}

.nav-tabs.list .nav-item .nav-link {
  text-transform: none;
}

.nav-item .badge {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: #ed7e63;
  height: 1.6rem;
  width: 1.6rem;
  border-radius: 50%;
}
</style>
